import React, { useContext, useEffect } from 'react';
import { DataGrid } from '@material-ui/data-grid';
import Skeleton from '@material-ui/lab/Skeleton';
import { store as mainStore } from '../../../../../store';
import { localText } from '../../../../../langs/fa/data-grid';
import { store } from './InsuranceSubtractions';
import { makeStyles } from '@material-ui/core/styles';
import NoIS from './NoIS';
import { useHistory } from 'react-router-dom';
import { __ } from '../../../../../utils/i18n';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import red from '@material-ui/core/colors/red';

const useStyles = makeStyles((theme) => ({
  danger: {
    color: red[500],
  },
}));

const ISList = () => {
  const classes = useStyles();
  const history = useHistory();
  const {
    showMessage,
    showError,
    state: {
      Props: { itemsCountPerPage },
    },
  } = useContext(mainStore);
  const {
    state: { insuranceSubtractions, isLoaded, page },
    dispatch,
    actions: { fetchingIS, deleteIS },
  } = useContext(store);
  const columns = [
    { field: 'min', headerName: 'حداقل ارزش‌بار', flex: 1 },
    { field: 'max', headerName: 'حداکثر ارزش‌بار', flex: 1 },
    { field: 'insurance', headerName: 'مبلغ بیمه', flex: 1 },
    {
      field: 'delete',
      headerName: 'حذف',
      renderCell: ({ row: { id } }) => {
        return (
          <IconButton onClick={() => handleDelete(id)}>
            <DeleteIcon className={classes.danger} />
          </IconButton>
        );
      },
      width: 100,
    },
  ];

  const handlePageChange = async ({ page }) => {
    dispatch({ type: 'CHANGE_PAGE', payload: page });
  };
  const handleSelectIS = (selection) => {
    const isId = selection.row.id;
    const is = insuranceSubtractions.docs.find((c) => c._id === isId);
    dispatch({ type: 'IS', payload: is });
  };
  const handleDelete = async (id) => {
    try {
      const message = await deleteIS(id);
      showMessage(message);
      const res = await fetchingIS(page, itemsCountPerPage);
      dispatch({ type: 'ISS', payload: res });
    } catch (error) {
      showError(error);
    }
  };

  useEffect(() => {
    (async () => {
      try {
        const res = await fetchingIS(page, itemsCountPerPage);
        dispatch({ type: 'ISS', payload: res });
      } catch (error) {
        showError(error);
      }
    })();
  }, [page]);

  return (
    <div style={{ width: '100%', height: 300 }}>
      <DataGrid
        rows={
          insuranceSubtractions && insuranceSubtractions.docs
            ? insuranceSubtractions.docs.map((i) => ({
                id: i._id,
                min: i.min,
                max: i.max,
                insurance: i.insurance,
              }))
            : []
        }
        columns={columns}
        localeText={localText}
        pageSize={itemsCountPerPage}
        rowCount={
          insuranceSubtractions && insuranceSubtractions.totalDocs
            ? insuranceSubtractions.totalDocs
            : 0
        }
        paginationMode="server"
        onPageChange={handlePageChange}
        loading={!isLoaded}
        disableMultipleSelection
        density="compact"
        components={{
          noRowsOverlay: NoIS,
        }}
        onCellClick={handleSelectIS}
      />
    </div>
  );
};

export default React.memo(ISList);
